import React from 'react'
import { Calendar, CalendarItem, Line } from './styles'
const HistoricCalendar = ({ valuations, active, onMonthClick }) => {
  const renderItems = () => {
    const items = valuations
    return items.map((item, index) => (
      <React.Fragment key={`${item?.year}-${item?.monthNumber}`}>
        <CalendarItem
          onClick={() => onMonthClick(item)}
          active={active.year === item?.year && active.month === item?.month}
        >
          <p style={{ fontSize: '14px' }}>{item.year}</p>
          <b style={{ fontSize: '24px', textTransform: 'uppercase' }}>
            {item.month}
          </b>
          <p style={{ fontSize: '11px' }}>
            {item.valuations.length > 1
              ? `${item?.valuations?.length} avaliações`
              : `1 avaliação`}
          </p>
        </CalendarItem>
        {index < items?.length - 1 && <Line />}
      </React.Fragment>
    ))
  }

  return <Calendar>{renderItems()}</Calendar>
}

export default HistoricCalendar
